/**
 * @desc 删除
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(params: API.mns.messageCategory.remove.Params, options?: any) {
  return updateResponse(
    http(URL + `/messageCategory/delete`, {
      method: "DELETE",
      params,

      ...options,
    }),
  );
}
